<template>
  <v-textarea ref="textarea" dir="auto" :rows="1" auto-grow hide-details="auto" variant="plain" class="my-0 pt-0 caret-post-text">
    <template v-for="(slot, name) in $slots" #[name]="scope">
      <slot :name="name" v-bind="scope ?? {}" />
    </template>
  </v-textarea>
</template>

<script>
export default {
  methods: {
    focus() {
      this.$refs.textarea.focus()
    },
    blur() {
      this.$refs.textarea.blur()
    },
    addEmoji(emoji) {
      document.execCommand("insertText", false, emoji)
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.v-field__field) {
  align-items: flex-start !important;
}

:deep(.v-field__input) {
  mask-image: none !important;
}

:deep(.v-counter) {
  color: var(--post-detail);
}
</style>
